import React, { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'

import './Nav.scss'

const Nav = ({ isOpen, routes = [], handleMobileToggle }) => {
  const [openSubnav, setOpenSubnav] = useState('')
  const location = useLocation()

  useEffect(() =>{
    const onClickOutside = ({ target }) => {
      const subNav = document.querySelector('.sub-nav__links')
      if (!subNav?.contains(target)) {
        setOpenSubnav('')
      }
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])

  useEffect(() =>{
    setOpenSubnav('')
  }, [location])

  return (
    <nav className={`primary-nav ${isOpen ? 'nav-open' : ''}`}>
      { routes.map(
        (route, index) => {
          if (!route.links || route.links.length === 1) {
            const href = route.url.replace('/:slug', '').replace(':category', 'all')
            return (
              <NavLink
                activeClassName="active"
                className="primary-nav__link"
                key={ `${route.url}_${index}` }
                to={ href }
                onClick={ handleMobileToggle }
                style={{flexBasis: `${100/routes.length}%`}}
              >
                { route.linkText }
              </NavLink>
            )
          }
          const subNavId = `${ route.linkText }_${index}`
          const hasActiveChild = matchPath(location.pathname, {
            path: route.url
          })

          return (
            <div
              className="sub-nav__wrapper"
              key={ `${route.url}_${index}` }
              style={{flexBasis: `${100/routes.length}%`}}
            >
              <button
                className={`sub-nav__trigger ${ hasActiveChild ? 'active' : ''}`}
                onClick={() => {
                  setOpenSubnav(openSubnav === subNavId ? '' : subNavId)
                }}
              >
                { route.linkText }
              </button>
              { openSubnav === subNavId &&
                <ul className="sub-nav__links">
                  { route.links.map(({ url, linkText }, subIndex) => (
                      <li
                        className="sub-nav__link-wrapper"
                        key={ `${url}_${subIndex}` }
                      >
                        <NavLink
                          activeClassName="active"
                          className="sub-nav__link"
                          to={ url }
                          onClick={ handleMobileToggle }
                        >
                          { linkText }
                        </NavLink>
                      </li>
                    ))
                  }
                </ul>
              }
            </div>
          )}
        )
      }
    </nav>
  )
}
export default Nav